export default __webpack_public_path__ + "static/media/lib-template2.b13228ba.png";